import {
  Component,
  OnInit,
  ComponentFactoryResolver,
  ViewChildren,
  QueryList,
  Input
} from '@angular/core';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import { SketchFieldComponent } from '../sketch-field/sketch-field.component';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  FormControl,
  Validators
} from '@angular/forms';
import { SketchDataEntity } from 'src/app/models/data-entities/sketch-data-entity';
import { Point } from 'node_modules/signature_pad/dist/types/point';
import { LayoutService } from 'src/app/services/layout.service';
import { WorkflowContextService } from 'src/app/services';

@Component({
    selector: 'wm-sketch-data-entity-view',
    templateUrl: './sketch-data-entity-view.component.html',
    styleUrls: ['./sketch-data-entity-view.component.css'],
    standalone: false
})
export class SketchDataEntityViewComponent extends DataEntityViewComponent
  implements OnInit {
  @ViewChildren(SketchFieldComponent) public sketches: QueryList<
    SketchFieldComponent
  >;
  @Input() form: UntypedFormGroup;
  imageDataPath: string;

  constructor(
    public layoutService: LayoutService,
    componentFactoryResolver: ComponentFactoryResolver,
    context : WorkflowContextService,
    private _fb: UntypedFormBuilder
  ) {
    super(layoutService, componentFactoryResolver, context);
  }

  ngOnInit() {
    let s: SketchDataEntity;
    s = <SketchDataEntity>this.entity;

    let value: { data: Array<Point[]>; image: string; path: string };

    if (typeof this.entity.value === 'string') {
      if ((this.entity.value || '') !== '' && this.entity.value.indexOf('{') !== -1) {
        value = JSON.parse(this.entity.value as string);
      }
    } else {
      value = this.entity.value;
    }

    if (value) {
      // Prefer an inline base64 image when the tablet/UI provides one; fall back to the
      // storage path when only a document reference was captured (parity with
      // SignatureDataEntityViewComponent).
      this.imageDataPath = value.image || value.path;
    }
  }
}
